import React, { useEffect, useRef } from 'react'
import './home.css'
import ServiceBox from '../../components/homeComponent/ServiceBox'
import { FaArrowRight } from "react-icons/fa6";
import OwlCarousel from 'react-owl-carousel';
import Header from '../../components/header/Header';
import Footer from '../../components/footer/Footer';
import { Link, useLocation } from 'react-router-dom';
import { CarouselData } from '../landing/datas';
import v2_video from '../../assets/video/solution-video.mp4';
import { Helmet } from 'react-helmet-async';


const Home = () => {

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const videoRef = useRef(null);
    useEffect(() => {
        const video = videoRef.current;
        if (video) {
            video.autoplay = true; // Set autoplay to true
            video.muted = true; // Set muted to true
            video.loop = true; // Set loop to true
        }
    }, [])

        const location = useLocation();
        console.log("location", location?.pathname);

    return (
        <>
            <Helmet>
                <title>Best Logistics app in Delhi NCR | Intercity Pick & Drop Services – iLine</title>
                <meta name="description" content="Discover iLine Logistics, the leading EV-only logistics app in Delhi. We offer reliable delivery services, parcel shipping, and comprehensive logistics solutions. Trust us for timely, secure deliveries and exceptional service tailored to your needs!" />
                <link rel="canonical" href={`https://iline.ai${location.pathname}`} />
            </Helmet>
            <Header />
            {/* <section className='NewWayModern'>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="nwmLeft">
                                <span>your partner for simplified delivery</span>
                                <h2>New way of your modern delivery</h2>
                                <p>We are the name of the game when it comes to moving things from point A to point B.</p>
                                <button className='Get'></button>
                            </div>
                        </div>
                        <div className="col-lg-6">

                        </div>
                    </div>
                </div>
            </section> */}

            <section className='HeroSectionNew'>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="hsnLeft" data-aos="fade-up" data-aos-delay="200">
                                <h6>Where affordability meet sustainability</h6>
                                <h2>New way of <br /> your modern<br /> delivery</h2>
                                <h4>Track your carbon impact in real-time, and enjoy efficient, <br /> reliable EV-powered logistics at affordable rates.</h4>
                                <Link className='GetAQuote' to="/contact" onClick={scrollToTop}>Contact Us</Link>
                            </div>
                        </div>
                    </div>
                    <div className="hsnRight">
                        <img src={require('../../assets/images/home/home-banner.png')} alt="img" />
                    </div>
                </div>

            </section>

            <section className='ServicesArea'>
                <div className="container">
                    <div className="row gy-4">
                        <div className="col-lg-4 col-md-12">
                            <div className="section-title">
                                <p data-aos="fade-up" data-aos-delay="200">our services</p>
                                {/* <h2 data-aos="fade-up" data-aos-delay="300">We provide full assistance in<br /> freight and warehousing.</h2> */}
                                <h2 data-aos="fade-up" data-aos-delay="250">From Click to Doorstep, with Care for the Planet</h2>
                                <Link to="/service" data-aos="fade-up" data-aos-delay="300">List of our services</Link>
                            </div>
                        </div>
                        <div className="col-lg-8 col-md-12">
                            <div className="row gy-4">
                                <ServiceBox />
                            </div>
                        </div>
                        <div className="col-lg-8 ms-auto">
                            <div className='ServiceBottom'>
                                <p>Our list of services does not end here. We’ll adapt to your particular needs.</p>
                                <Link to="/contact" onClick={scrollToTop}>Contact Us for Your Business <FaArrowRight /></Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className='LogisticSolutions'>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="lsLeft">
                                {/* <iframe id="myIframe" className="services-area" sandbox="allow-scripts allow-popups allow-forms allow-same-origin"
                             src="https://www.youtube.com/watch?v=_pI5GDgQxKQ"  width="100%" height='500px' target="_self" title="Iframe Example"></iframe> */}


                                <iframe width="100%" height="315" src="https://www.youtube.com/embed/_pI5GDgQxKQ?si=uu0Li3HzHhRkC6Id" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>


                                {/* <figure>
                                    <video src={require('../../assets/video/solution-video.mp4')} autoPlay muted className='img-fluid'></video>
                                </figure> */}
                                {/* aaa */}
                                {/* <div className="youtube-container" style={{ textAlign: 'center', marginTop: '20px' }}>
                                    <iframe
                                        width="560"
                                        height="315"
                                        src={require('../../assets/video/video.mp4')} autoPlay muted className='img-fluid'
                                        title="YouTube video"
                                        frameBorder="0"
                                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                        allowFullScreen
                                    ></iframe> */}

                                {/* <video src='' muted /> */}
                                {/* <video autoPlay muted   src={v2_video} ref={videoRef}/> */}
                                {/* </div> */}
                                <span className='Overlay'>
                                    {/* s<img src={require('../../assets/images/dots-corner.svg')} /> */}
                                </span>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="lsRight">
                                <h2 data-aos="fade-up" data-aos-delay="200">Logistics Solutions</h2>
                                <p data-aos="fade-up" data-aos-delay="200">Providing an independent advice and identifying the right fit for you. Services are sourced and procured based on solution specifications provided by our Supply Chain Solution.</p>
                                {/* <a href="javascript:void(0)" className='BrandBtn' data-aos="fade-up" data-aos-delay="200">Read More</a> */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* <section className='Accomplishments'>
                <div className="container">
                    <div className="Top">
                        <div className="section-title">
                            <p>ACCOMPLISHMENTS
                            </p>
                            <h2>Let the <br /> numbers speak <br /> for themselves.
                            </h2>
                        </div>
                        <figure><img src={require('../../assets/images/img-1.jpg')} /></figure>
                    </div>
                    <div className="row">
                        <div className="col-lg-4">
                            <div className="AccomPulishBox">
                                <h2 className='Number'>5,731</h2>
                                <h5>Delivered packages.</h5>
                                <p>We strongly support best practice sharing across our operations around the world and across various industrial sectors.</p>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="AccomPulishBox">
                                <h2 className='Number'>123</h2>
                                <h5>Countries covered.</h5>
                                <p>As one of the world’s leading supply chain management companies, we design and implement industry-leading solutions.</p>
                            </div>

                        </div>
                        <div className="col-lg-4">
                            <div className="AccomPulishBox">
                                <h2 className='Number'>5,731</h2>
                                <h5>Tons of goods.</h5>
                                <p>Our commitment to sustainability helps us reduce waste and share the benefits with our customers.</p>
                            </div>
                        </div>
                    </div>
                </div>


            </section> */}

            <section className='HelpArea'>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-5 col-md-12">
                            <div className="HelpLeft">
                                <h2>How we Empower Logistics Business
                                </h2>
                                <figure><img src={require('../../assets/images/img-2.jpg')} alt='img' /></figure>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div className='TopLine'>
                                <span className='TopLineLeft'><img src={require('../../assets/images/home/main_circle.svg').default} alt='img' /></span>
                                <span className='TopLineRight'>
                                    <img src={require('../../assets/images/home/small_circle.svg').default} alt='img' />
                                </span>

                            </div>
                            <div className='CenterLine'>
                                <span className='CenterLineRight'>
                                    <img src={require('../../assets/images/home/small_circle.svg').default} alt='img' />
                                </span>
                                <span className='FirstCenterLine'></span>
                            </div>
                            <div className='BottomLine'>
                                <span className='BottomLineRight'>
                                    <img src={require('../../assets/images/home/small_circle.svg').default} alt='img' />
                                </span>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-12">
                            <div className="HelpRight">
                                <ul>
                                    <li>
                                        <h3>Eco-Friendly Fleet Solutions</h3>
                                        {/* <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p> */}
                                    </li>
                                    <li>
                                        <h3>Sustainable Business Practices</h3>
                                        {/* <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p> */}
                                    </li>
                                    <li>
                                        <h3>AI-Powered Efficiency</h3>
                                        {/* <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p> */}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                </div>
            </section>


            {/* <section className='TestimomnialArea'>
                <div className="container">
                    <div className="section-title">
                        <h2>Testimonials</h2> */}
            {/* <p>With lots of unique blocks, you can easily build a page without<br /> coding. Build your next landing page.</p> */}
            {/* </div> */}
            {/* <div className="row gy-5">
                        {
                            CarouselData?.map((item) => {
                                return (
                                    <div className="col-lg-4 col-md-6">
                                        <div class='item'>
                                            <div className="TestimonialBox">
                                                <h3>{item?.content}</h3>
                                                <aside>
                                                    <figure><img src={item?.imgsrc} alt='img' /></figure>
                                                    <figcaption>
                                                        <h6>{item?.name}</h6>
                                                        <p>{item?.position}</p>
                                                    </figcaption>
                                                </aside>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div> */}
            {/* <OwlCarousel 
                    className="owl-theme"
                    loop
                    margin={10}
                    autoplay={true} 
                    autoplayTimeout={3000} 
                    autoplayHoverPause={true} 
                    responsive={{
                      0: {
                        items: 1, 
                      },
                      600: {
                        items: 1,
                      },
                      1000: {
                        items: 3,
                      }
                    }}
                    >
                        {
                            CarouselData?.map((item) => {
                                return (
                                    <div class='item'>
                                        <div className="TestimonialBox">
                                            <h3>{item?.content}</h3>
                                            <aside>
                                                <figure><img src={item?.imgsrc} alt='img' /></figure>
                                                <figcaption>
                                                    <h6>{item?.name}</h6>
                                                    <p>{item?.position}</p>
                                                </figcaption>
                                            </aside>
                                        </div>
                                    </div>
                                )
                            })
                        }

                    </OwlCarousel>
                </div>
            </section> */}


            {/* <section className='WhatOurClientsSay'>
                <div className="container">
                    <div className="section-title">
                        <h2>What our clients say
                        </h2>
                    </div>
                    <OwlCarousel className='owl-theme' loop margin={10} items={2} >
                        <div class='item'>
                            <div className="ClientBox">
                                <h3>"My shipment was picked up and delivered with excellent service! Needless to say I am extremely satisfied with the results. Will definitely use this service again."</h3>
                                <aside>
                                    <figure><img src={require('../../assets/images/landing-images/profile-img.png')} /></figure>
                                    <figcaption>
                                        <h5>Leo Benderson Linchin</h5>
                                        <p>CEO, GeoBoost LTD</p>
                                    </figcaption>
                                </aside>
                            </div>
                        </div>
                        <div class='item'>
                            <div className="ClientBox">
                                <h3>"My shipment was picked up and delivered with excellent service! Needless to say I am extremely satisfied with the results. Will definitely use this service again."</h3>
                                <aside>
                                    <figure><img src={require('../../assets/images/landing-images/profile-img.png')} /></figure>
                                    <figcaption>
                                        <h5>Leo Benderson Linchin</h5>
                                        <p>CEO, GeoBoost LTD</p>
                                    </figcaption>
                                </aside>
                            </div>
                        </div>
                        <div class='item'>
                            <div className="ClientBox">
                                <h3>"My shipment was picked up and delivered with excellent service! Needless to say I am extremely satisfied with the results. Will definitely use this service again."</h3>
                                <aside>
                                    <figure><img src={require('../../assets/images/landing-images/profile-img.png')} /></figure>
                                    <figcaption>
                                        <h5>Leo Benderson Linchin</h5>
                                        <p>CEO, GeoBoost LTD</p>
                                    </figcaption>
                                </aside>
                            </div>
                        </div>
                        <div class='item'>
                            <div className="ClientBox">
                                <h3>"My shipment was picked up and delivered with excellent service! Needless to say I am extremely satisfied with the results. Will definitely use this service again."</h3>
                                <aside>
                                    <figure><img src={require('../../assets/images/landing-images/profile-img.png')} /></figure>
                                    <figcaption>
                                        <h5>Leo Benderson Linchin</h5>
                                        <p>CEO, GeoBoost LTD</p>
                                    </figcaption>
                                </aside>
                            </div>
                        </div>
                        <div class='item'>
                            <div className="ClientBox">
                                <h3>"My shipment was picked up and delivered with excellent service! Needless to say I am extremely satisfied with the results. Will definitely use this service again."</h3>
                                <aside>
                                    <figure><img src={require('../../assets/images/landing-images/profile-img.png')} /></figure>
                                    <figcaption>
                                        <h5>Leo Benderson Linchin</h5>
                                        <p>CEO, GeoBoost LTD</p>
                                    </figcaption>
                                </aside>
                            </div>
                        </div>
                        <div class='item'>
                            <div className="ClientBox">
                                <h3>"My shipment was picked up and delivered with excellent service! Needless to say I am extremely satisfied with the results. Will definitely use this service again."</h3>
                                <aside>
                                    <figure><img src={require('../../assets/images/landing-images/profile-img.png')} /></figure>
                                    <figcaption>
                                        <h5>Leo Benderson Linchin</h5>
                                        <p>CEO, GeoBoost LTD</p>
                                    </figcaption>
                                </aside>
                            </div>
                        </div>
                    </OwlCarousel>;
                </div>
            </section> */}

            <Footer />

        </>
    )
}

export default Home;